import { render, staticRenderFns } from "./SyncExpress.vue?vue&type=template&id=60ca0fb4&scoped=true&"
import script from "./SyncExpress.vue?vue&type=script&lang=js&"
export * from "./SyncExpress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ca0fb4",
  null
  
)

export default component.exports